export default __webpack_public_path__ + "book_details-language.cdd14ced.png";